module.exports = __webpack_public_path__ + "static/media/message.15f3e35f.svg";